import { render, staticRenderFns } from "./player-container.vue?vue&type=template&id=594441b8&scoped=true"
import script from "./player-container.vue?vue&type=script&lang=js"
export * from "./player-container.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594441b8",
  null
  
)

export default component.exports